export default {
  //login page
  tagline: "العمل الذكي يبدأ هنا.",
  subtext: "قم بتسجيل الدخول لتحسين عملياتك الميدانية.",
  emailLabel: "البريد الإلكتروني",
  passwordLabel: "كلمة المرور",
  emailPlaceholder: "البريد الإلكتروني",
  passwordPlaceholder: "كلمة المرور",
  forgotPassword: "نسيت كلمة المرور؟",
  forgotPasswordTip: "لا تقلق! أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور بأمان.",
  signIn: "تسجيل الدخول",
  copyrightText: "حقوق النشر فیلڈ فورس",
  returnToLogin: "العودة لتسجيل الدخول",
  enterOTPAndResetPassword: "أدخل رمز OTP المكون من 6 أرقام المرسل إلى بريدك الإلكتروني وأنشئ كلمة مرور قوية وفريدة.",

  //sidebar
  dashboard: "لوحة التحكم",
  analytics: "التحليلات",
  forms: "النماذج",
  logout: "تسجيل الخروج",

  //task and its sub menus
  task: "المهمة",
  taskList: "قائمة المهام",
  planner: "المخطط",
  locate: "تحديد الفريق",
  taskTarget: "هدف المهمة",
  archiveTask: "المهام المؤرشفة",

  //manage and its sub menu
  manage: "الإدارة",
  visitProfile: "ملف الزيارة",
  employee: "الموظف",
  permissions: "الأذونات",
  status: "الحالة",
  searchHere: "ابحث هنا....",
  permissionGroup: "مجموعة الأذونات",
  officeLocation: "موقع المكتب",
  team: "الفريق",
  product: "المنتج",
  designation: "الوظيفة",
  designationLevel: "مستوى الوظيفة",
  doctor: "الطبيب",
  department: "القسم",
  doctorSpecialization: "تخصص الطبيب",
  doctorDesignation: "وظيفة الطبيب",
  practiceLocation: "موقع الممارسة",
  practiceLocationType: "نوع موقع الممارسة",
  locationType: "نوع الموقع",
  employmentStatus: "حالة التوظيف",
  customerRank: "رتبة العميل",
  subTask: "المهمة الفرعية",
  taskStatus: "حالة المهمة",
  taskType: "نوع المهمة",
  taskPriority: "أولوية المهمة",
  city: "المدينة",
  country: "البلد",
  role: "الدور",
  specialization: "التخصص",
  getOTP: "احصل على OTP",

  //components
  downloadSummary: "تحميل الملخص",
  addTask: "إضافة مهمة",
  viewNotes: "عرض الملاحظات",
  taskDetails: "تفاصيل المهمة",
  addNew: "إضافة جديد",
  filters: "المرشحات",
  hide: "إخفاء",
  search: "بحث",
  of: "من",
  visitDate: "تاريخ الزيارة",
  accompaniedBy: "برفقة (اختياري)",
  assignTo: "تعيين إلى",
  assignedTo: "تم التعيين إلى",
  assignedBy: "تم التعيين بواسطة",
  assignToMe: "تعيين لي",
  name: "الاسم",
  shortName: "الاسم المختصر",
  firstName: "الاسم الأول",
  lastName: "اسم العائلة",
  doctorName: "اسم الطبيب",
  personalContact: "رقم الاتصال الشخصي",
  contact: "رقم الاتصال",
  dateOfJoining: "تاريخ الانضمام",
  cnicNo: "رقم البطاقة الوطنية",
  gender: "الجنس",
  passportNo: "رقم جواز السفر",
  personalEmail: "البريد الإلكتروني الشخصي",
  address: "العنوان",
  headOffice: "المكتب الرئيسي",
  displayName: "الاسم المعروض",
  createdOn: "تاريخ الإنشاء",
  reportsTo: "يرفع التقارير إلى",
  officialDetails: "التفاصيل الرسمية",
  description: "الوصف",
  active: "نشط؟",
  save: "حفظ",
  cancel: "إلغاء",
  addAnother: "أضف آخر",
  addDoctor: "إضافة طبيب",
  submitPlan: "إرسال الخطة",
  myPlan: "خطتي",
  month: "شهر",
  week: "أسبوع",
  day: "يوم",
  selectEmployee: "اختر الموظف",
  personalDetails: "التفاصيل الشخصية",
  addEmployee: "إضافة موظف",
  clearAll: "مسح جميع المرشحات",
  myTasks: "مهامي",
  subOrdinates: "التابعين",
  newPassword: "كلمة المرور الجديدة",
  confirmPassword: "تأكيد كلمة المرور",
  emailNotReceivedTip: "إذا لم تستلم البريد الإلكتروني خلال 5 دقائق، تحقق من مجلد الرسائل المزعجة.",
  resendOTP: "إعادة إرسال OTP",
  tryAgain: "حاول مرة أخرى",
  or: "أو",
  submit: "إرسال",
  noDataFound: "لم يتم العثور على بيانات",
  onLeave: "في إجازة",
  enterLeaveMessage: "أدخل رسالة الإجازة هنا",
  leaveMessage: "رسالة الإجازة",
  visitTime: "وقت الزيارة",
  start: "ابدأ",
  end: "انتهى",
  callAverage: "متوسط المكالمات",
  callAverageByTable: "متوسط المكالمات حسب الجدول",
  callAverageByEmployee: "متوسط المكالمات حسب الموظف",
  callAverageByProduct: "متوسط المكالمات حسب المنتج",
  callAverageByPracticeLocation: "متوسط المكالمات حسب موقع الممارسة",
  kol: "كول",
  activeEmployee: "الموظف النشط",
  totalDoctors: "إجمالي الأطباء",
  visitProfiles: "ملفات الزيارة",
  practiceLocations: "مواقع الممارسة",
  createdBy: "تم الإنشاء بواسطة",
  lastLogin: "آخر تسجيل دخول",
  lastUpdated: "آخر تحديث",
  action: "الإجراء",
  title: "العنوان",

  //add actions
  addVisitProfile: "إضافة ملف زيارة",
  addPermissionGroup: "إضافة مجموعة أذونات",
  addPermissionGroupTip: "حدد مستوى الوصول والأذونات",
  addOfficeLocation: "إضافة موقع المكتب",
  addOfficeLocationTip: "أدخل تفاصيل موقع مكتب الشركة",
  addTeam: "إضافة فريق",
  addTeamTip: "إنشاء فرق لإدارة المستخدمين وتحسين التعاون",
  addProduct: "إضافة منتج",
  addProductTip: "أدخل معلومات المنتج والوثائق ذات الصلة",
  addDesignation: "إضافة وظيفة",
  addDesignationTip: "تعيين وإدارة المناصب الوظيفية في المؤسسة",
  addDepartment: "إضافة قسم",
  addDepartmentTip: "إنشاء قسم جديد وإدارة توزيع الفريق",
  addDoctorDesignation: "إضافة وظيفة الطبيب",
  addDoctorDesignationTip: "إضافة وظيفة جديدة للأطباء",
  addDoctorSpecialization: "إضافة تخصص الطبيب",
  addDoctorSpecializationTip: "تعيين تخصص جديد للأطباء",
  addPracticeLocation: "إضافة موقع ممارسة",
  addPracticeLocationTip: "أضف موقع ممارسة جديد",
  addCustomerRank: "إضافة رتبة العميل",
  addCustomerRankTip: "تعيين رتبة لتصنيف العملاء",
  addSubTasks: "إضافة مهام فرعية",
  addSubTasksTip: "إنشاء مهمة صغيرة يمكن إدارتها ضمن مهمة أكبر",
  addCity: "إضافة مدينة",
  addCityTip: "أدخل مدينة أدناه",
  addRole: "إضافة دور",
  addRoleTip: "حدد الدور ومجموعة الأذونات ذات الصلة",
  addEmploymentStatus: "إضافة حالة التوظيف",
  addEmploymentStatusTip: "حدد حالة التوظيف",
  addTaskPriority: "إضافة أولوية المهمة",
  addTaskPriorityTip: "تعيين مستوى عاجل لتحديد أولوية إتمام المهمة",
  pastePlan: "لصق الخطة",
  pastePlanTip: "هذه هي التواريخ المنسوخة. انقر على التاريخ الهدف لتعديله إذا لزم الأمر",
  paste: "لصق",
  pasteMonthlyPlanConfirm: "أنت على وشك لصق خطة شهرية. هذا سيحل محل الزيارات المضافة مسبقًا لهذا الشهر. هل تريد المتابعة؟",
  addItem: "أضف جديد {{item}}",
  createNewItemRecord: "إنشاء سجل جديد لـ {{item}}",
  jobLocation: "موقع العمل",
  officialEmail: "البريد الإلكتروني الرسمي",
  officialContact: "رقم الاتصال الرسمي",
  employeeId: "معرّف الموظف",
  applyFilters: "تطبيق الفلاتر",
  select: "اختر",
  from: "من",
  to: "إلى",
  noDataMessage: "لا توجد بيانات للعرض. 'قم بتطبيق أو تغيير الفلاتر'",
  custom: "مخصص",
  apply: "تطبيق",
  reset: "إعادة تعيين",
  date: "التاريخ",
  calls: "المكالمات",
  notes: "ملاحظات",
  enterTaskNote: "أدخل ملاحظة المهمة",
  taskNote: "ملاحظة المهمة",
  addNote: "إضافة ملاحظة",
  attachments: "المرفقات",
  statusHistory: "سجل الحالة",
  add: "إضافة",
  type: "النوع",
  levelOrder: "ترتيب المستوى",
  addDesignationLevel: "إضافة مستوى المسمى الوظيفي",
  addDesignationLevelTip: "سيحدد هذا مستوى المسمى الوظيفي في التسلسل الهرمي",
  lowerNumberHierarchyTip: "تشير الأرقام الأصغر إلى مستويات أعلى في التسلسل الهرمي.",
  color: "اللون",
  addCities: "إضافة مدينة",
  addCitiesTip: "أدخل مدينة أدناه.",
  attachedDocuments: "المستندات المرفقة",
  noFilesAttached: "لا توجد ملفات مرفقة",
  clickToUpload: "انقر للرفع",
  acceptedFormats: "الصيغ المقبولة",
  viewDetails: "عرض التفاصيل",
  total: "المجموع",
  created: "تم الإنشاء",
  inReview: "قيد المراجعة",
  approved: "موافق عليه",
  inProgress: "قيد التنفيذ",
  rejected: "مرفوض",
  cancelled: "ملغى",
  onHold: "قيد الانتظار",
  reScheduled: "معاد جدولته",
  completed: "مكتمل",
  doctorUnavailable: "الطبيب غير متاح",
  refusedToMeet: "رفض المقابلة",
  visitComplete: "الزيارة مكتملة",
  submitted: "تم الإرسال",
  submitPlan: "تقديم الخطة",
  submitPlanTip: "لن تتمكن من إجراء التغييرات بعد التقديم، هل أنت متأكد أنك تريد المتابعة؟",
  approvePlan: "الموافقة على الخطة",
  approvePlanTip: "هل أنت متأكد أنك تريد الموافقة على هذه الخطة الشهرية؟ سوف يتم إنهاء المراجعة لهذا الموظف.",
  rejectPlan: "رفض الخطة",
  rejectPlanTip: "هل أنت متأكد أنك تريد رفض هذه الخطة الشهرية؟ سيحتاج الموظف إلى مراجعة الخطة وإعادة تقديمها للمراجعة.",
  approve: "موافقة",
  addSuggestionsHere: "أضف الاقتراحات هنا",
  noRejectionNotes: "لا توجد ملاحظات رفض متاحة",
  rejectionNotes: "ملاحظات الرفض",
  time: "الوقت",
  update: "تحديث",
  map: "خريطة",
  chooseLocation: "اختر الموقع",
  loadingMap: "جارٍ تحميل الخريطة",
  displayAddress: 'عنوان العرض',
  enterDisplayAddress: 'أدخل عنوان العرض'

};
